export default {
  searching: 'Searching...',
  deleteConfirmation: 'Are you sure that you want to remove this HCPCS?',
  deleteError: 'An error occurred while deleting the product line.',
  productLine: {
    save: 'Product line saved successfully.',
    update: 'Product line updated successfully.',
    delete: 'Product line deleted successfully.',
    cancel: 'Product line cancelled successfully.',
    duplicate: 'The product line was duplicated successfully.',
    saveError: 'An error occurred while saving the product line.',
    saveGeneralInformation: 'General information updated successfully.',
    saveAdverseDetermination: 'Adverse Determination updated successfully.',
  }
}
